var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.75H15.6706C15.753 5.75 15.8301 5.79061 15.8767 5.85856L19.9934 11.8586C20.0519 11.9438 20.0519 12.0562 19.9934 12.1414L15.8767 18.1414C15.8301 18.2094 15.753 18.25 15.6706 18.25H4C3.86193 18.25 3.75 18.1381 3.75 18V6C3.75 5.86193 3.86193 5.75 4 5.75Z",
    stroke: "#7177A8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLabel);
export default __webpack_public_path__ + "static/media/icon_label.9bdd89ea27e9a597b35e96d3cd7c44ab.svg";
export { ForwardRef as ReactComponent };